import { AxiosRequestConfig, AxiosResponse, AxiosInstance, AxiosInterceptorManager } from 'axios'
export enum ContentType {
  JSON = 'application/json;charset=UTF-8',
  STREAM = 'application/octet-stream; =;charset=UTF-8',
  FORM_DATA = 'multipart/form-data'
}

export interface HttpRequestConfig extends AxiosRequestConfig {
  disableError?: boolean
}

export interface HttpResponse<T = any> extends AxiosResponse<T> {
  config: HttpRequestConfig
}

export interface HttpInstance extends AxiosInstance {
  post<T = any>(url: string, data?: any, config?: HttpRequestConfig): Promise<T>
  interceptors: {
    request: AxiosInterceptorManager<HttpRequestConfig>
    response: AxiosInterceptorManager<HttpResponse>
  }
}
